/**
 * API service barrel.
 *
 * Re-exports all domain-specific API modules so that existing imports of
 * `../../services/api` (default import and named exports) continue to work
 * unchanged after the split into domain files.
 *
 * New code should import directly from the domain files:
 *   import { usersApi } from "./users.api";
 *   import { authApi  } from "./auth.api";
 *   import { finanzasApi } from "./finanzas.api";
 */
import { authApi } from "./auth.api";
import { recoveryApi } from "./auth.api";
import { usersApi } from "./users.api";
import { finanzasApi } from "./finanzas.api";
import { propiedadesApi } from "./propiedades.api";
import { aseosApi } from "./aseos.api";
import { inventarioApi } from "./inventario.api";
import { tareasApi } from "./tareas.api";
import { historialApi } from "./historial.api";
import { estadisticasApi } from "./estadisticas.api";
import { finanzasEmpresaApi } from "./finanzasEmpresa.api";
import { finanzasTrabajadorApi } from "./finanzasTrabajador.api";
import { contratosApi } from "./contratos.api";
import { expenseRecipientsApi } from "./expenseRecipients.api";
import { agendaMaestrosApi } from "./agendaMaestros.api";
import { costosSugeridosApi } from "./costosSugeridos.api";
import { mercadoApi } from "./mercado.api";
import { resumenMensualApi } from "./resumenMensual.api";
import { botAsistenteApi } from "./botAsistente.api";
import { API_BASE_URL, getAuthToken } from "./apiClient";

export { authApi, recoveryApi } from "./auth.api";
export { usersApi } from "./users.api";
export { finanzasApi } from "./finanzas.api";
export { propiedadesApi } from "./propiedades.api";
export { aseosApi } from "./aseos.api";
export { inventarioApi } from "./inventario.api";
export { tareasApi } from "./tareas.api";
export { historialApi } from "./historial.api";
export { estadisticasApi } from "./estadisticas.api";
export { finanzasEmpresaApi } from "./finanzasEmpresa.api";
export { finanzasTrabajadorApi } from "./finanzasTrabajador.api";
export type {
  MesFinanzaTrabajador,
  FinanzasTrabajadorResponse,
} from "./finanzasTrabajador.api";
export { contratosApi } from "./contratos.api";
export {
  expenseRecipientsApi,
  listExpenseRecipients,
  createExpenseRecipient,
  updateExpenseRecipient,
  deleteExpenseRecipient,
} from "./expenseRecipients.api";
export type {
  ExpenseRecipient,
  CreateExpenseRecipientPayload,
  UpdateExpenseRecipientPayload,
  DeleteExpenseRecipientResponse,
} from "./expenseRecipients.api";
export { agendaMaestrosApi } from "./agendaMaestros.api";
export type { Maestro, MaestroCreate } from "./agendaMaestros.api";
export { costosSugeridosApi } from "./costosSugeridos.api";
export type { CostoSugerido, CostoSugeridoCreate } from "./costosSugeridos.api";
export { staysRecalcApi } from "./staysRecalc.api";
export type { RecalcBookingArgs, RecalcBookingResponse, RecalcDelta } from "./staysRecalc.api";
export { alertsApi } from "./alerts.api";
export type { Alerta, AlertaNivel, AlertaEstado } from "./alerts.api";
export { notificacionesApi } from "./notificaciones.api";
export type { Notificacion, NotificacionesLista } from "./notificaciones.api";
export { mercadoApi } from "./mercado.api";
export type {
  MercadoEstado,
  MercadoCodigo,
  MercadoRango,
  MercadoSerie,
  MercadoSettings,
  MercadoSettingsResponse,
  ResumenClienteResponse,
  MercadoPropiedadCliente,
  MercadoFechaCliente,
} from "./mercado.api";
export { resumenMensualApi, descargarResumenMensual, ErrorDescargaResumen } from "./resumenMensual.api";
export type { FormatoResumen, DescargaResumenParams } from "./resumenMensual.api";
export { botAsistenteApi, FRASE_MODO_REAL, FRASE_VACIAR_SIMULACIONES } from "./botAsistente.api";
export { API_BASE_URL, getAuthToken } from "./apiClient";

// Default export keeps `import api from "../../services/api"` working.
const apiService = {
  API_BASE_URL,
  getAuthToken,
  authApi,
  usersApi,
  recoveryApi,
  finanzasApi,
  propiedadesApi,
  aseosApi,
  inventarioApi,
  tareasApi,
  historialApi,
  estadisticasApi,
  finanzasEmpresaApi,
  finanzasTrabajadorApi,
  contratosApi,
  expenseRecipientsApi,
  agendaMaestrosApi,
  costosSugeridosApi,
  mercadoApi,
  resumenMensualApi,
  botAsistenteApi,
};

export default apiService;
